@if (titleLabel() || titleIcon()) {
  <div class="title-wrapper">
    @if (titleLabel()) {
      <span class="title-label">{{ titleLabel() }}</span>
    }
    @if (titleIcon()) {
      <app-icon
        [id]="titleIconId()"
        [name]="titleIcon()!"
        [color]="'#1976d2'"
        style="cursor: pointer"
        (click)="titleIconClick.emit()"
      ></app-icon>
    }
  </div>
}

<div [attr.id]="id()">
  <ng-content></ng-content>
</div>

<div class="info-label-container" [class.invalid]="invalid()">
  @if (invalid()) {
    <span>*</span>
  }
  <span>{{ infoLabel() }}</span>
</div>
